// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e25ed5ba","952":"386d8864"}[chunkId] + ".chunk.js";
};